import React, { memo, useCallback } from "react";
import { Box, makeStyles, Divider } from "@material-ui/core";
import { useHistory, Switch, Route } from "react-router-dom";
import { useSelector } from "react-redux";

import DrawerToggle from "./DrawerToggle";
import SectionMinifiedCard from "./SectionMinifiedCard";
import SectionFullCard from "./SectionFullCard";
import RouteDefaultsCard from "../RouteDefaultsCard";
import { PAGE_START, SECTION_FULL_PAGE } from "../../../../constants/routes";
import useLocationQueryParams from "../../../../hooks/useLocationQueryParams";
import palette from "../../../styles/palette";
import {
  getDefaultRoutes,
  getSections,
} from "../../../../store/selectors/sections";
import { ListWrapper } from "../RouteComponents/ListWrapper";

const useStyles = makeStyles(() => ({
  headerDivider: {
    background: palette.typography.white.neutral,
  },
  divider: {
    height: "0.125rem",
    background: "transparent",
  },
}));

const colors = ["#84C546", "#44A7DF", "#E3AD1A"];

const SectionList = ({ onTabChange, onSectionClick, onSectionDoubleClick }) => {
  const styles = useStyles();
  const history = useHistory();
  const { sectionId } = useLocationQueryParams();
  const defaultRoutes = useSelector(getDefaultRoutes);
  const sections = useSelector(getSections);

  const renderItems = useCallback(
    (items, ListItem) =>
      Object.keys(items).map((key, i) => {
        const { sectionCode } = items[key];

        return (
          <Box key={sectionCode}>
            <Divider className={styles.divider} />
            <ListItem
              {...items[key]}
              spot={colors[i % 3]}
              active={parseInt(sectionId) === parseInt(sectionCode)}
              onClick={() => onSectionClick(sectionCode)}
              onDoubleClick={() => onSectionDoubleClick(sectionCode)}
            />
          </Box>
        );
      }),
    [sectionId, onSectionClick, onSectionDoubleClick]
  );

  return (
    <>
      <DrawerToggle value={history.location.pathname} onChange={onTabChange} />
      <Divider className={styles.headerDivider} />
      <ListWrapper>
        {Object.keys(defaultRoutes).map((routeId) => (
          <Box key={defaultRoutes[routeId].routeName}>
            <Divider className={styles.headerDivider} />
            <RouteDefaultsCard route={defaultRoutes[routeId]} />
          </Box>
        ))}
        <Switch>
          <Route exact path={PAGE_START}>
            {renderItems(sections, SectionMinifiedCard)}
          </Route>
          <Route path={SECTION_FULL_PAGE}>
            {renderItems(sections, SectionFullCard)}
          </Route>
        </Switch>
      </ListWrapper>
    </>
  );
};

export default memo(SectionList);
